// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  font-family: var(--font-family-base);
}

.uT41Ye {
  display: flex;
  min-height: 100vh;
  max-width: 100vw;
  background: #ffffff;
  width: 100%;
  justify-content: center;
  overflow-x: hidden;
}

.emxaVZ {
  display: flex;
  width: 100%;
  max-width: var(--grid-breakpoint-l);
  min-width: 0;
  position: relative;
  overflow-x: hidden;
}

.jE0ZMD {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

._L9bdW {
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
}

.hBYzWK {
  background-color: var(--background-alt);
  flex: 1;
  padding-right: 24px;
  padding-left: 24px;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
}

.Zc5flq {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 355px;
  background: var(--surface-neutral-soft);
}

.IOlXkg {
  display: grid;
  padding: 16px;
}

.A5wE0S {
  width: 50;
  background: var(--surface-neutral-soft);
  padding: 16;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  font-size: 10px;
}

.wxItT2 {
  grid-column: span 4;
  background: var(--surface-neutral-soft);
  padding: 16;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  font-size: 10px;
}

.RbQKAd {
  display: flex;
  align-items: center;
  gap: 16px;
}

.B9vDnI {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}

.B9vDnI:hover {
  background: #f5f5f5;
}

.QuKst_ {
  height: 24px;
  display: flex;
  align-items: center;
}

.fb1fWb {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-layout/src/layouts/AppLayout.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,OAAO;EACP,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,uCAAuC;EACvC,OAAO;EACP,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[":root {\n  font-family: var(--font-family-base);\n}\n\n.appRoot {\n  display: flex;\n  min-height: 100vh;\n  max-width: 100vw;\n  background: #ffffff;\n  width: 100%;\n  justify-content: center;\n  overflow-x: hidden;\n}\n\n.appInnerContainer {\n  display: flex;\n  width: 100%;\n  max-width: var(--grid-breakpoint-l);\n  min-width: 0;\n  position: relative;\n  overflow-x: hidden;\n}\n\n.appMain {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.appContentRow {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow-x: hidden;\n}\n\n.appContent {\n  background-color: var(--background-alt);\n  flex: 1;\n  padding-right: 24px;\n  padding-left: 24px;\n  min-height: 0;\n  min-width: 0;\n  overflow-x: hidden;\n}\n\n.appShortcuts {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 355px;\n  background: var(--surface-neutral-soft);\n}\n\n.gridContainer {\n  display: grid;\n  padding: 16px;\n}\n\n.gridItem {\n  width: 50;\n  background: var(--surface-neutral-soft);\n  padding: 16;\n  border-radius: 8px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  font-size: 10px;\n}\n\n.gridItemFull {\n  grid-column: span 4;\n  background: var(--surface-neutral-soft);\n  padding: 16;\n  border-radius: 8px;\n  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);\n  font-size: 10px;\n}\n\n.mobileHeaderContent {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.mobileMenuButton {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n}\n\n.mobileMenuButton:hover {\n  background: #f5f5f5;\n}\n\n.mobileLogoContainer {\n  height: 24px;\n  display: flex;\n  align-items: center;\n}\n\n.mobileLogoImage {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appRoot": `uT41Ye`,
	"appInnerContainer": `emxaVZ`,
	"appMain": `jE0ZMD`,
	"appContentRow": `_L9bdW`,
	"appContent": `hBYzWK`,
	"appShortcuts": `Zc5flq`,
	"gridContainer": `IOlXkg`,
	"gridItem": `A5wE0S`,
	"gridItemFull": `wxItT2`,
	"mobileHeaderContent": `RbQKAd`,
	"mobileMenuButton": `B9vDnI`,
	"mobileLogoContainer": `QuKst_`,
	"mobileLogoImage": `fb1fWb`
};
module.exports = ___CSS_LOADER_EXPORT___;
